<template>
    <div class="modal-window mbs010">
        <header class="modal-header">
            <div class="tit" v-if="$i18nUtil.getLanguage() === 'ko'">{{ $i18nUtil.trans("title.MainTermsAndPolicy.001","이용약관/개인정보 취급방침") }}</div>
            <div class="tit" v-if="$i18nUtil.getLanguage() !== 'ko'">{{ $i18nUtil.trans("title.MainTermsAndPolicy.002","이용약관") }}</div>
            <!-- <button @click="$emit('close')" class="btn_close">닫기</button> -->
        </header>
        
        <div class="modal-content">
            <div class="tab_ty2" id="tabsTy1">
                <ul class="tab-menu" :class="{enCss: $i18nUtil.getLanguage() === 'en'}">
                    <li v-for="(tab, index) in tabsTy1" :key="index" v-bind:class="{active:currentTab1===index}">
                    <button type="button" v-on:click="currentTab1 = index">{{tab}}</button>
                    </li>
                </ul>
                <div class="tab-content">
                    <UseTerms v-show="currentTab1 == 0"/>
                    <PrivacyPolicy v-show="currentTab1 == 1"/>
                </div>
            </div>
            <input type="checkbox" id="isAgree" v-model="isAgree">
                <label for="isAgree" v-if="$i18nUtil.getLanguage() === 'ko'">{{ $i18nUtil.trans("message.MainTermsAndPolicy.001","이용약관/개인정보 취급방침에 동의합니다.") }}</label>
                <label for="isAgree" v-if="$i18nUtil.getLanguage() !== 'ko'">{{ $i18nUtil.trans("message.MainTermsAndPolicy.002","이용약관에 동의합니다.") }}</label>
        </div>
        <footer class="modal-footer">
            <!-- <button type="button" class="btn_ty1" @click="$emit('close')">확인</button> -->
            <button type="button" class="btn_ty1" @click="agreePrivacy">{{ $i18nUtil.trans("button.confirm","확인") }}</button>
        </footer>
    </div>  
</template>

<script>
import { mapState, mapActions } from "vuex";
import UseTerms from "@/components/cowork/join/modal/UseTerms";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import PrivacyPolicy from "@/components/cowork/join/modal/PrivacyPolicy";
import EventBus from "@/js/eventbus/eventBus";
export default {
    props : {
        modalInfo: {
            urlPath: String,
            required: true,
        },
    },
    components: {
        UseTerms,
        PrivacyPolicy
    },
    data() {
        return { 
            isAgree : false,
            currentTab1: 0,
            tabsTy1: [],

        };
    },
    mounted() {
        if(this.$i18nUtil.getLanguage() === 'ko') {
            let tab = [ this.$i18nUtil.trans("title.UseTerms.001","이용약관"), this.$i18nUtil.trans("title.PrivacyPolicy.001","개인정보 취급방침") ];
            this.tabsTy1 = tab
        }else{
            let tab = [ this.$i18nUtil.trans("title.UseTerms.001","이용약관") ]
            this.tabsTy1 = tab
        }
    },
    methods: {
        ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        agreePrivacy() {
            let obj = this;
            if(obj.isAgree) {
                let reqData = {
                    url : "/api/auth/org/changePrivacyStatus",
                    method : "post",
                    params: {},
                };
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(function (res) {
                    if(res.errorCode !== null) {
                        let errorCode = res.errorCode;
                    } else {
                        if(obj.modalInfo.type === "UPD") {
                            obj.$router.replace(obj.modalInfo.urlPath);
                        }
                        EventBus.$emit("showExpire");
                        obj.$emit("close");
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
            } else {
                let msg = obj.getLanguage() === 'ko' ? 
                        obj.$i18nUtil.trans("AG043", "이용약관/개인정보 처리방침에 동의하셔야 가입이 가능합니다.") 
                        : obj.$i18nUtil.trans("AG043.001", "이용약관에 동의하셔야 가입이 가능합니다.");

                let info = {
                    title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                    button : obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                    contents : msg,
                };
                obj.handleDialog(info);
            }
        },
        /* 알림 Dialog */
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
    },
}
</script>

<style scoped>
    .tab_ty2 > .enCss li button {
        padding: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/MainTermsAndPolicy.vue